module.exports = __webpack_public_path__ + "static/media/paystack.3be85e2a.svg";